<template>
  <b-skeleton-wrapper :loading="loading">
    <template #loading>
      <div class="roles">
        <b-skeleton
          v-for="(item, index) in items"
          :key="`a-${index}`"
          width="100%"
          class="height-48 margin-bottom-16"
        ></b-skeleton>
      </div>
    </template>
    <slot name="default"></slot>
  </b-skeleton-wrapper>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Number,
      default: 6,
    },
  },
  computed: {
    items() {
      const arr = [];
      arr.length = this.count;
      return arr;
    },
  },
};
</script>
